import { SUPPORTED_ROLES } from "@/constants/roles";
import { fetchData } from "@/services/api";
import { useAuth } from "@/services/auth";
import { userHasRole } from "@/utils/users";
import { forEach } from "lodash";
import LogRocket from "logrocket";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { isClient } from "../styles/utils";
import { useCurrentUser } from "./useCurrentUser";

export const useIdentify = (configs = {}) => {
  const { autoTriggerIdentifyCalls } = configs;
  const { authenticated } = useAuth();
  const [identified, setIdentified] = useState(false);
  const router = useRouter();
  const { user } = useCurrentUser();

  useEffect(() => {
    if (identified) setIdentified(false);
  }, [router.asPath]);

  useEffect(() => {
    if (!isClient() || identified || !autoTriggerIdentifyCalls) return;
    triggerIdentifyCalls();
  }, [authenticated, user, identified]);

  const triggerIdentifyCalls = async () => {
    if (!user || !window?.analytics) return;

    let newUser;
    if (user?.name == "Error") {
      newUser = await fetchData("/user");
    } else {
      newUser = user;
    }

    // Construct builder and colour room strings

    let builders = "";
    let colourRooms = "";

    forEach(newUser?.builders, (builder, i) => {
      if (!builder?.name) return;
      builders = `${builders}${i > 0 ? ", " : ""}${builder?.name}`;
    });

    forEach(newUser?.colour_rooms, (room, i) => {
      if (!room?.name) return;
      colourRooms = `${colourRooms}${i > 0 ? ", " : ""}${room?.name}`;
    });

    // Construct roles data

    let roles = {
      isSuperAdmin: userHasRole(newUser, "Super Admin") || false,
      isAdmin: userHasRole(newUser, "Admin") || false,
      isSupportAdmin: userHasRole(newUser, ...SUPPORTED_ROLES) || false,
      isRoomManager: userHasRole(newUser, "Room Manager") || false,
      isBuilderManager: userHasRole(newUser, "Builder Manager") || false,
      isConsultant: userHasRole(newUser, "Consultant") || false,
      isStoreperson: userHasRole(newUser, "Storeperson") || false,
    };

    LogRocket?.identify?.(newUser.email, {
      name: newUser.name,
      email: newUser.email,
    });

    window.analytics.identify(
      newUser.id,
      {
        name: newUser.name,
        email: newUser.email,
        company: newUser?.active_builder?.name,
        builders,
        colourRooms,
        ...roles,
        ...newUser?.report,
      },
      () => {
        setIdentified(true);
      },
    );
  };

  return { triggerIdentifyCalls };
};
